export const movementReasonOptions = [
  { key: 'Preview', value: 'Preview', text: 'Preview' },
  { key: 'Restoration', value: 'Restoration', text: 'Restoration' },
  { key: 'Digitisation', value: 'Digitisation', text: 'Digitisation' },
];
